import Layout from '../../../Components/Layout/Layout';
import { Container, Card, Button } from 'react-bootstrap';
import { AiFillCloseCircle } from 'react-icons/ai';
import './FailedPayment.css';
import { Link, useSearchParams } from 'react-router-dom';

const FailedPayment = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('user_type') as 'B2B' | 'Exhibitor' | 'Visitor';

  return (
    <Layout showHeader>
      <Container className='failed-wrapper d-flex justify-content-center align-items-center'>
        <Card
          className='failed-card text-center p-4 shadow-lg'
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <AiFillCloseCircle className='failed-icon mb-3' />

          <h3 className='failed-title'>Payment Failed!</h3>
          <p className='failed-text'>
            Something went wrong. Your payment could not be processed.
          </p>

          <Link
            to={
              type === 'Visitor'
                ? '/visitor/invoice'
                : type === 'B2B'
                ? '/b2b/invoice'
                : `/profile/billing-info`
            }
            style={{ width: '100%' }}
          >
            {' '}
            <Button variant='primary' className='mt-3 common-btn submit-button'>
              Try Again
            </Button>
          </Link>
        </Card>
      </Container>
    </Layout>
  );
};

export default FailedPayment;
